import React, { useState } from "react";
import { Edit } from "lucide-react";
import LoadingSkeleton from "../general/skeleton";
import Modal from "../general/modal";
import { Form } from "../general/form";
import { toast } from "react-hot-toast";
import { back_office_axi } from "../../context/authContext";

export const DetailCard = ({
  title,
  loading,
  customWidth,
  children,
  editableData,
  clientId,
  setClient,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState(editableData || {});
  const [editLoading, setEditLoading] = useState(false);
  const [originalData] = useState(editableData || {});

  const handleEditSubmit = async () => {
    // Check if anything was changed
    const hasChanges = Object.keys(editFormData).some(
      (key) => editFormData[key] !== originalData[key],
    );

    if (!hasChanges) {
      toast.error("Nothing to save");
      return;
    }

    try {
      setEditLoading(true);
      
      const payload = { ...editFormData };
      delete payload.commission;

      const data = {
        ...payload,
        // WE CAST RATE_PER_LIMIT TO FLOAT,
        // Initially sending as string from the form, but backend expects a number, so we convert it here.
        // If it's empty or invalid, we default to 0.
        rate_per_unit: parseFloat(editFormData.rate_per_unit) || 0,
      };

      const response = await back_office_axi.put(
        `/api/clients/update-client/${clientId}`,
        data,
      );

      toast.success("Profile updated successfully", { duration: 5000 });
      setClient(response?.data?.client);
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(
        error?.response?.data?.message || "Failed to update profile",
        { duration: 5000 },
      );
    } finally {
      setEditLoading(false);
    }
  };

  const editFormFields = [
    {
      type: "text",
      name: "name",
      label: "Client Name",
      placeholder: "Enter client name",
      value: editFormData.name || "",
      required: true,
    },
    {
      type: "select",
      name: "color_scheme",
      label: "Color Scheme",
      placeholder: "Select color scheme",
      value: editFormData.color_scheme || "",
      required: true,
      options: [
        { label: "Select color", value: "" },
        { label: "Orange", value: "orange" },
        { label: "Blue", value: "blue" },
        { label: "Green", value: "green" },
        { label: "Purple", value: "purple" },
        { label: "Red", value: "red" },
      ],
    },
    {
      type: "text",
      name: "rate_per_unit",
      label: "Amount Per Unit",
      placeholder: "Enter rate per unit",
      value: editFormData.rate_per_unit || "",
      required: true,
    },
    {
      type: "text",
      name: "reorder_limit",
      label: "Reorder Limit",
      placeholder: "Enter reorder limit",
      value: editFormData.reorder_limit || "",
    },
    {
      type: "number",
      name: "min_amount",
      label: "Min Amount",
      placeholder: "Enter min amount",
      value: editFormData.min_amount || "",
    },
    {
      type: "number",
      name: "max_amount",
      label: "Max Amount",
      placeholder: "Enter max amount",
      value: editFormData.max_amount || "",
    },
  ];

  return (
    <>
      <LoadingSkeleton loading={loading}>
        <div
          className={`w-full bg-white relative px-3 py-2 rounded-2xl font-nexa flex flex-col justify-start 
          ${customWidth ? customWidth : "inline-flex"}`}
        >
          <div className="flex items-center justify-between mb-2">
            <h2 className="font-nexa text-xl text-primary-dark leading-10 m-0">
              {title}
            </h2>
            {editableData && clientId && (
              <button
                onClick={() => setIsEditModalOpen(true)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                title="Edit profile"
              >
                <Edit size={20} className="text-primary-dark" />
              </button>
            )}
          </div>
          <div className="w-full pb-2">{children}</div>
        </div>
      </LoadingSkeleton>

      {/* Edit Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onClose={() => {
          setEditFormData(originalData);
          setIsEditModalOpen(false);
        }}
        title="Edit Profile Details"
      >
        <Form
          fields={editFormFields}
          onSubmit={handleEditSubmit}
          formData={editFormData}
          setFormData={setEditFormData}
          isLoading={editLoading}
          btnText="Save Changes"
          grid={2}
        />
      </Modal>
    </>
  );
};

// import React from "react";
// import LoadingSkeleton from "../general/skeleton";

// export const DetailCard = ({ title, loading, customWidth, children }) => {
//   return (
//     <LoadingSkeleton loading={loading}>
//       <div
//         className={`w-full bg-white relative px-3 py-2 rounded-2xl font-nexa flex flex-col justify-start
//           ${customWidth ? customWidth : "inline-flex"}`}
//       >
//         <h2 className="font-nexa text-xl text-primary-dark leading-10 m-0 mb-2">{title}</h2>
//         <div className="w-full pb-2">
//           {children}
//         </div>
//       </div>
//     </LoadingSkeleton>
//   );
// };
